// web/src/polyfills.js
// Ensure window is defined in a Node.js-like environment for build process
if (typeof window === 'undefined') {
  global.window = {}
}

// Ensure localStorage is defined
if (!window.localStorage) {
  Object.defineProperty(window, 'localStorage', {
    value: {
      getItem: () => null,
      setItem: () => {},
      removeItem: () => {},
      clear: () => {},
      length: 0,
      key: () => null
    },
    writable: true
  })
}
